module.exports = __webpack_public_path__ + "img/logo_segurify.cf637351.png";